<template>
  <section>
    <HeaderBar :my-title="myHeader" :is-prev="isPrevShow"></HeaderBar>
    
    <div v-html="myDetail.content" class="proDetail-cont"></div>
  </section>
  
  

</template>

<script>
import FooterBar from './base/footer'
import HeaderBar from './base/header'

export default {
  components: {
    HeaderBar,
  
  },
  props: {
   
    
  },
  name: 'problemDetail',
  created: function () {
      this.getParams()
   //http://localhost:6001/api/faq/detail/1
     this.$http.get('/api/faq/detail/'+this.myIdx+'')
        .then((response)=> {
        
          this.myDetail = response.data.data

           
        })
        .catch((error) =>{
          console.log(error);
        });
       
  },
 
  data () {
    return {
      myHeader:"详情",
      isPrevShow:true,
      myIdx:'',
      myDetail:''
    }
  },
  methods:{
     getParams () {
          // 取到路由带过来的参数 
          let routerParams = this.$route.query.myIdx
          // 将数据放在当前组件的数据内
          this.myIdx = routerParams
         

      
     }
  },
  
    mounted(){
    

    }  
}
</script>


<style>
.problem-list{font-size: 0.3rem;color: #999999;margin-top: 0.35rem;height: 1rem;overflow:hidden;}
.problem-list li{float: left;margin-right: 0.54rem;height: 100%;}
.problem-list li:nth-of-type(1){margin-left: 1.71rem}
.problem-list .active{color: #000;background: url(../assets/problem-list.png) no-repeat center 0.58rem;background-size: 0.5rem 0.08rem;}

.proDetail-cont p{font-size: 0.3rem;line-height: 0.5rem}
.proDetail-cont strong{font-weight: normal;}
.proDetail-cont img{width: 100%;margin: 0.2rem 0}
.proDetail-cont{padding: 0.5rem 0.25rem 0 0.25rem;font-size: 0.3rem}
</style>



// WEBPACK FOOTER //
// src/components/problemDetail.vue